import { Injectable } from '@angular/core';
import { DestroyableComponent } from '@models/destroyable.component';
import { User } from 'lingo2-models';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LibrarySidebarService extends DestroyableComponent {
  public useFilter$ = this.register(new BehaviorSubject<boolean>(true));
  public contentPage$ = this.register(new BehaviorSubject<boolean>(false));
  public user$ = this.register(new BehaviorSubject<User>(null));

  public enableFilter() {
    this.useFilter$.next(true);
  }

  public disableFilter() {
    this.useFilter$.next(false);
  }

  public enableContentPage() {
    this.contentPage$.next(true);
  }

  public disableContentPage() {
    this.contentPage$.next(false);
  }

  public setUser(user: User) {
    this.user$.next(user);
  }
}
